// extracted by mini-css-extract-plugin
export default {"container":"NoAttorney_container__krBf6"};